export const commonSlice = (set) => ({
	loading: false,
	setLoading: (loading) => set({ loading }),
});
